import moment from 'moment';
import { dateTransferFormat } from '../../webcommon/common/constants';


export const PAGE_REFRESH_RATE = 60000;

const getLastBusinessDay = (givenDate) => {
    let newDate = givenDate;
    while (newDate.format('ddd') === 'Sun' || newDate.format('ddd') === 'Sat') {
        newDate = newDate.subtract(1, 'days');
    }
    return newDate;
};

export const filterDefinitions = [
    {
        id: 'date',
        type: 'date',
        title: 'Date'
    },
    {
        id: 'counterparties',
        type: 'list',
        title: 'Counterparties',
        availableValuesLocation: 'api:SystemInfo/counterparties',
        wide: true,
        includeGroupTitle: false
    }
];

const lastBusinessDay = getLastBusinessDay(moment().subtract(1, 'days'));

export const defaultFilters = [
    {
        definition: filterDefinitions.find(d => d.id === 'date'),
        value: {
            to: lastBusinessDay.format(dateTransferFormat),
            from: getLastBusinessDay(lastBusinessDay.subtract(2, 'months')).format(dateTransferFormat)
        }
    },
    {
        definition: filterDefinitions.find(d => d.id === 'counterparties'),
        value: []
    }
];
